import { ActividadEconomica } from "../ActividadEconomica";
import { Ambiente } from "../Ambiente";
import { ConfiguracionEmision } from "../ConfiguracionEmision";
import { PersonaAutorizada } from "../PersonaAutorizada";
import { PlantillaImpresion } from "../PlantillaImpresion/PlantillaImpresion";
import { Reseller } from "../Reseller/Reseller";
import { Sucursal } from "../Sucursal";

export class Emisor {
	emisorId: string;
	rut: number;
	razonSocial: string;
	giro: string;
	dirPart: string;
	dirFact: string;
	correoPar: string;
	correoFact: string;
	ciudad: string;
	comuna: string;
	nroResol: number;
	fechaResol: Date;
	ambiente: number;
	activo: boolean;
	suspendidoPorMora?: boolean;
	dv: string;
	rutString: string;
	sucursales: Sucursal[];
	actividadesEconomicas: ActividadEconomica[];
	configuracionDte: ConfiguracionEmision[];
	personasAutorizadas: PersonaAutorizada[];
	nombreAmbiente: string;
	ambienteEnt: Ambiente;
	representanteLegalRut: number;
	representanteLegalDv: string;
	representanteLegalRutString: string;
	telefono: number;
	plantillasPdfOfEmisor: PlantillaImpresion[];
	passwordSii: string;
	tienePassSii: boolean;
	resellerId: string;
	reseller: Reseller;
	unidadSII: string;
	planUsuarioId: string;
	actual: boolean;
	envioAutomaticoCorreos: boolean;
	envioAutomaticoCopiaCedible: boolean;
	totalUsuarios: number;
	totalDTEEmitidos: number;
	totalBHEEmitidos: number;
	totalAdicionalesEmitidos: number;
	periodo: string;
	maxDTE: number;
	maxBHE: number;
	maxUsuarios: number;
	nombrePlan: string;
	precioPlan: number;
	valorAdicional: number;
	logo: string;
	passwordVerificada: boolean;
	bheEmpresa: boolean;
	bheMultiRut: boolean;
	bheSyncAutomatica: boolean;
	bheSyncDiasSinNuevos: number;
	bheSyncFechaActivacion?: Date;
	showActions?: boolean;
}
